import React from 'react';
import {Link} from 'react-router';

const InfoColumns = ({title = '', titleRedirect='', columns = []}) => {
    return (
        <React.Fragment>
            <div className={`stats-title green`}>
                {titleRedirect ?
                    <Link to={titleRedirect} >{title}</Link>
                    :
                    {title}
                }
            </div>
            <div className='stats-info-container'>
                {columns.map((column, index) => (                    
                    <div className={title== 'Closed Since 2022' ? 'stats-info-Closed' : 'stats-info-columns'} key={index}>
                        <React.Fragment>
                            <div className='stats-info-value'>
                                {column.value}
                            </div>
                            <div className={`stats-info-title ${column.className && column.className}`}>
                                {column.key}
                            </div>
                        </React.Fragment>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
};

export default InfoColumns;